import { FC } from 'react'
import { LoaderWithText } from '@/ui/components/loader-with-text'
import { ScanIndicatorWrapper } from './inlineScanIndicator.styles'

interface InlineScanIndicatorProps {
    scanInProgress: boolean
    text?: string
}

const InlineScanIndicator: FC<InlineScanIndicatorProps> = ({
    scanInProgress,
    text = 'Scan in progress',
}) => {
    if (!scanInProgress) return null

    return (
        <ScanIndicatorWrapper>
            <LoaderWithText text={text} />
        </ScanIndicatorWrapper>
    )
}

export default InlineScanIndicator
